import React, { Fragment } from "react";
import { Grid, Divider } from "@material-ui/core";
import _ from "lodash";
import styled from "styled-components";
import { connect as reduxConnect } from "react-redux";
import { connect, replace } from "formik";
import { compose } from "redux";
import moment from "moment";
import { AutoCompleteInput, MoneyInput, PercentInput, DatePicker, TextInput, IntegerInput } from "components/Global/FormikMaterial";

import { RecourseChildSection, PersonalGuarantors, CompanyGuarantors } from "./RecourseSectionChildren";
import { SectionTitle } from "./FormSectionComponents";

const VerticalSpacer = styled.div`
height:30px;
display:block;
`;
class RecourseSection extends React.Component {
  render() {
    const { formik, isEditing, isQuote, setFieldValue } = this.props;

    return (
      <>
        <VerticalSpacer />
        <SectionTitle id="recourse_section">Recourse</SectionTitle>
        <RecourseChildSection isEditing={isEditing} setFieldValue={setFieldValue} isQuote={isQuote} />
        {!isQuote && <>
          <VerticalSpacer />
          <PersonalGuarantors loanId={this.props.loanId} isEditing={isEditing} />
          <VerticalSpacer />
          <CompanyGuarantors loanId={this.props.loanId} isEditing={isEditing} />
                     </>}

      </>
    );
  }
}

const mapStateToProps = ({ }) => ({
});

export default compose(
  connect,
  reduxConnect(
    mapStateToProps,
    {
    }
  )
)(RecourseSection);
